
<template>
  <div>
    <v-container fluid v-if="true">
      <v-card style="border-radius:12px" v-if="oneClient">
        <v-card-title primary-title>
          <h3 class="headline mb-0">{{oneClient.name}}</h3>
          <v-spacer></v-spacer>
          <v-btn color="primary" :to="'/clients/edit/'+oneClient.id" rounded><v-icon left>mdi-pencil</v-icon>editar</v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="overflow-y:auto; max-height: 720px">
          <!-- <v-form ref="formClient" v-model="validClient" lazy-validation> -->
            <v-container fluid class="pa-0 px-1" >
              <v-expansion-panels popout v-model="panels">
                <v-expansion-panel class="mt-1" style="border-radius:8px">
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <div class="subtitle dark-grey--text mr-1">Dados do cliente</div>
                      <!-- <div class="dark-grey--text text--darken-3">{{oneClient.name}}</div> -->
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content >
                    <v-container grid-list-xs>
                      <v-chip outlined class="mb-2" :color="oneClient.client_is=='corporate'? 'secondary' : 'success'">
                        <v-icon left>mdi-{{oneClient.client_is=='corporate'? 'domain' : 'account'}}</v-icon>
                        <div class="font-weight-bold">{{ oneClient.client_is=='corporate'? 'Pessoa Jurídica' : 'Pessoa Física' }}</div>
                      </v-chip>
                      <v-row justify="space-around">
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.name" prepend-icon="mdi-account" label="Nome"></v-text-field>
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.corporate_info.corporate_name" prepend-icon="mdi-domain" label="Nome Fantasia" v-if="oneClient.client_is=='corporate'"></v-text-field>
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.corporate_info.state_inscription" prepend-icon="mdi-information" label="Inscrição estadual" v-if="oneClient.client_is=='corporate'"></v-text-field>
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.corporate_info.city_inscription" prepend-icon="mdi-information" label="Inscrição municipal" v-if="oneClient.client_is=='corporate'"></v-text-field>
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.document_number" prepend-icon="mdi-account-card-details" v-mask='oneClient.client_is =="natural"? mask_cpf: mask_cnpj' :label="oneClient.client_is=='natural'? 'CPF':'CNPJ'"></v-text-field>
                        <v-text-field class="mr-1" single-line outlined readonly v-model="oneClient.email" prepend-icon="mdi-email" label="Email"></v-text-field>
                        <v-text-field single-line outlined readonly v-model="oneClient.corporate_info.responsible" prepend-icon="mdi-account-circle" label="Responsável" v-if="oneClient.client_is=='corporate'"></v-text-field>
                      </v-row>
                      <v-text-field single-line outlined readonly :value="oneClient.address.full_address" prepend-icon="mdi-map-marker" label="Endereço"></v-text-field>
                      <input-phone :is_readonly="true" :phones.sync="oneClient.phones"></input-phone>
                      <v-layout row wrap justify-end v-if="false && !is_new">
                        <!-- PASSAR PARA DENTRO DO COMPONENTE ^ -->
                        <v-btn class="mx-4" text icon color="success" @click="submitSaveItem(idx)"> <v-icon style="font-size: 20px">mdi-content-save</v-icon> </v-btn>
                        <!-- <v-btn class="mx-4" text icon color="error" @click="remove_contract(idx)"> <v-icon style="font-size: 20px">mdi-delete</v-icon> </v-btn> -->
                      </v-layout>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-1" style="border-radius:8px">
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <div class="subtitle dark-grey--text mr-1">Processos do cliente </div>
                      <!-- <div class="dark-grey--text text--darken-3">{{oneClient.name}}</div> -->
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content >
                    <v-container fluid>
                      <index-table :headers="headers" :items="all_litigations" :deletion_enabled="false" @editing="editing($event)"></index-table>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-1" style="border-radius:8px">
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <div class="subtitle dark-grey--text mr-1">Faturas do cliente </div>
                      <!-- <div class="dark-grey--text text--darken-3">{{oneClient.name}}</div> -->
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content >
                    <v-container fluid>

                      <client-bill></client-bill>
                      <!-- <index-table :headers="headers" :items="all_litigations" :deletion_enabled="false" @editing="editing($event)"></index-table> -->
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          <!-- </v-form> -->
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog_litigation" v-if="dialog_litigation" scrollable  persistent max-width="800px" transition="dialog-transition" >
        <v-card style="border-radius:12px">
          <v-card-title primary-title>
            <v-row align="baseline">
              <div class="body-1 mb-0">Processo:</div>
              <div class="headline mb-0 ml-1">{{one_litigation.name}}</div>
              <v-spacer></v-spacer>
              <v-btn text fab small color="primary" @click="dialog_litigation = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-timeline dense clipped>
                
                <v-timeline-item key="new" :color="add_progress?'red':'success'" >
                  <template v-slot:icon>
                    <v-icon color="white" @click="add_progress = !add_progress">mdi-{{add_progress? 'close':'plus'}}-circle</v-icon>
                  </template>
                  <v-slide-y-transition >
                    <v-card style="border-radius:12px" v-if="add_progress">
                      <v-card-title primary-title>
                        <div class="subititle mb-0">Novo andamento</div>
                      </v-card-title>
                      <v-card-text v-if="true">
                        <v-select :items="all_progresses" v-model="one_litigation.new_progress.p_obj" item-text="text" return-object label="Andamento" prepend-icon="mdi-debug-step-over" ></v-select>
                        <v-dialog ref="dialog_c_litigation_date" width="290px" >
                          <template v-slot:activator="{ on }">
                            <v-text-field :value="formatDate(one_litigation.new_progress.processed_at)" prepend-icon="mdi-calendar" label="Movimentado em" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="one_litigation.new_progress.processed_at" scrollable locale="pt-br">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="$refs.dialog_c_litigation_date.save(one_litigation.new_progress.processed_at)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-text-field v-model="one_litigation.new_progress.description" label="Descrição" prepend-icon="mdi-information-outline"></v-text-field>
                        <v-text-field v-model="one_litigation.new_progress.internal_comment" label="Comentário interno" prepend-icon="mdi-chat-outline mdi-flip-h" ></v-text-field>
                      </v-card-text>
                      <v-card-actions class="justify-end">
                        <v-btn rounded text color="error" @click="add_progress = false"><v-icon left>mdi-close-circle</v-icon>Cancelar</v-btn>
                        <v-btn rounded text color="success" @click="submitNewProgress"> <v-icon left>mdi-content-save</v-icon> salvar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-slide-y-transition>
                </v-timeline-item>

              <v-slide-x-transition group >
                <v-timeline-item v-for="(prg, idx) in timeline" :key="prg.id" :color="colors[idx%5]" icon="mdi-debug-step-over mdi-rotate-270">
                  <v-alert :value="true" :color="colors[idx%5]"  class="white--text" prominent border="left">
                    <v-row class="pl-3 pr-2 mb-2">
                      <span><v-icon color="black">mdi-chevron-right</v-icon> {{prg.name}} -  Movimentado em: {{prg.processed_at}}</span>
                    </v-row>
                    <v-row class="pl-3 pr-2 mb-2" v-if="prg.description">
                      <span><v-icon color="black">mdi-information-outline</v-icon> {{prg.description}}</span>
                    </v-row>
                    <v-row class="pl-3 pr-2" v-if="prg.internal_comment">
                      <div><v-icon color="black" class="mdi-flip-h">mdi-chat-outline</v-icon> {{prg.internal_comment}}</div>
                    </v-row>
                    <v-row class="pl-3 pr-2">
                      <div><v-icon color="black" class="mdi-flip-h">mdi-calendar</v-icon> Criado em: {{prg.created_at}}</div>
                    </v-row>
                  </v-alert>
                </v-timeline-item>
              </v-slide-x-transition>
            </v-timeline>

          </v-card-text>
          <v-divider v-if="false"></v-divider>
          <v-card-actions class="justify-end" v-if="false">
            <v-btn text color="error" @click="dialog_litigation = false">Cancelar</v-btn>
            <v-btn text color="success"> <v-icon left>mdi-content-save</v-icon> Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>
    </v-container>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
import { mask } from 'vue-the-mask'
import Api from '../../api/index'

export default {
  directives: {
    mask,
    currency: CurrencyDirective
  },
  components: {
    CardAddress: ()=> import('@/components/shared/CardAddress.vue'),
    InputPhone: ()=> import('@/components/shared/InputPhone.vue'),
    IndexTable: () => import('@/components/shared/IndexTable'),
    ClientBill: () => import('@/components/financial/bills/ClientBill'),
  },
  data() {
    return {
      dialog_litigation: false,
      one_litigation: null,

      add_progress:false,

      all_progresses: [
        {text: 'Despacho inicial', value: 'initial_dispatch'},
        {text: 'Citação', value: 'quote'},
        {text: 'Fase de contestação', value: 'contest_phase'},
        {text: 'Fase de impugnação', value: 'impugnation_phase'},
        {text: 'Fase de perícia', value: 'skill_phase'},
        {text: 'Saneado', value: 'sanitized'},
        {text: 'Concluso para sentença', value: 'conclusion_to_sentence'},
        {text: 'Fase recursal', value: 'appeal_phase'},
        {text: 'Execução de sentença', value: 'sentence_enforcement'},
        {text: 'Arquivado', value: 'filed'},
        {text: 'Extinto', value: 'extinct'},
        {text: 'Concluso para despacho', value: 'concluded_for_dispatch'},
        {text: 'Proferido despacho', value: 'dispatched'}
      ],

      headers:[
        { text: 'Número', width: '30%' ,align: 'left', sortable: true, value: 'name'},
        { text: 'Contrato', width: '30%' ,align: 'left', sortable: true, value: 'contract_name'},
        { text: 'Andamento', width: '30%' ,align: 'left', sortable: true, value: 'last_progress_name'},
        { text: 'Pasta', width: '30%' ,align: 'left', sortable: true, value: 'folder'},
        { text: 'Ação', width: '30%' ,align: 'center', value: 'action', sortable: false },
      ],
      litigations_fake:[
        {id: 1, name: '111' , contract_name: '555', last_progress: 'Saneado', folder: '23',},
        {id: 2, name: '222' , contract_name: '   ', last_progress: 'Citação', folder: '33',},
        {id: 3, name: '333' , contract_name: '777', last_progress: 'Pericia', folder: '43',},
        {id: 4, name: '444' , contract_name: '   ', last_progress: 'Recurso', folder: '53',},
        {id: 5, name: '555' , contract_name: '999', last_progress: 'Arquivado', folder: '63',},
      ],
      progresses_fake: [
        {id: 1, name: 'initial_dispatch', processed_at: '2019-12-01', description: ' Casamentiss faiz malandris se pirulitá. Mais vale um bebadis conhecidiss, que um alcoolatra anonimis.', internal_comment: 'Mussum Ipsum, cacilds vidis litro abertis. Em pé sem cair, deitado sem dormir, sentado sem cochilar e fazendo pose.'},
        {id: 2, name: 'quote', processed_at: '2019-12-02', description: ' Casamentiss faiz malandris se pirulitá. Mais vale um bebadis conhecidiss, que um alcoolatra anonimis.', internal_comment: 'Mussum Ipsum, cacilds vidis litro abertis. Em pé sem cair, deitado sem dormir, sentado sem cochilar e fazendo pose.'},
        // {id: 3, name: 'contest_phase', processed_at: '2019-12-03', description: ' Casamentiss faiz malandris se pirulitá. Mais vale um bebadis conhecidiss, que um alcoolatra anonimis.', internal_comment: 'Mussum Ipsum, cacilds vidis litro abertis. Em pé sem cair, deitado sem dormir, sentado sem cochilar e fazendo pose.'},
        // {id: 4, name: 'impugnation_phase', processed_at: '2019-12-04', description: ' Casamentiss faiz malandris se pirulitá. Mais vale um bebadis conhecidiss, que um alcoolatra anonimis.', internal_comment: 'Mussum Ipsum, cacilds vidis litro abertis. Em pé sem cair, deitado sem dormir, sentado sem cochilar e fazendo pose.'},
        // {id: 5, name: 'skill_phase', processed_at: '2019-12-04', description: ' Casamentiss faiz malandris se pirulitá. Mais vale um bebadis conhecidiss, que um alcoolatra anonimis.', internal_comment: 'Mussum Ipsum, cacilds vidis litro abertis. Em pé sem cair, deitado sem dormir, sentado sem cochilar e fazendo pose.'},
      ],
      loading: false,
      loadingText: null,

      currency:{
        currency: null,
        locale: 'en',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      oneClient: null,
      mask_cpf: '###.###.###-##',
      mask_cnpj: '##.###.###/####-##',

      colors: [
        'grey darken-1',
        'deep-purple lighten-1',
        'indigo lighten-1',
        'blue darken-3',
        'blue-grey lighten-1',
      ],


      panels: 1,

    }
  },
  computed: {
    timeline(){
      if (this.one_litigation){
        return this.one_litigation.progresses_attributes.data.filter(o => o.id).map(o => o.attributes ).slice().reverse()
      }
    },
    all_litigations(){
      if (this.oneClient){
        return this.oneClient.all_litigations.filter(o=>o.id)
      }
    },
    is_new() {
      return this.$route.name.includes('New') 
    },
    ...mapState({
      oneClientVuex: state=> state.Client.oneClient,

      createClientWasGood: state=> state.Client.createClientWasGood,
      createClientMessage: state=> state.Client.createClientMessage,

      updateClientWasGood: state=> state.Client.updateClientWasGood,
      updateClientMessage: state=> state.Client.updateClientMessage,
    })
  },
  methods: {
    // formatProgressName(v){
    //   return this.all_progresses.find(o=>o.value == v).text
    // },
    formatDate(d){
      if (!d) return null

      const [year, month, day] = d.split('-')
      return `${day}/${month}/${year}`
      // return d
    },
    editing(id) {
      this.loading = true
      this.loadingText = "Carregando"
      // setTimeout(() => {
        // this.$router.push('/clients/show/'+id)
      // }, 1200);
      Api.Litigation.show(id)
        .then(response=>response.data)
        .then(liti=>{
          this.one_litigation = {
            ...liti.data.attributes,
            new_progress: {},
            // progresses_attributes: [...this.progresses_fake]
          }
          this.loading = false
          this.loadingText = null
          this.dialog_litigation = true
        })
    },
    submitNewProgress(){
      this.loading = true
      this.loadingText = 'Salvando'
      setTimeout(() => {
        this.add_progress = false
      }, 1200);
      setTimeout(() => {
        this.loading = null
        this.loadingText = null
        setTimeout(() => {
          // this.one_litigation.new_progress.id = this.one_litigation.progresses_attributes[this.one_litigation.progresses_attributes.length-1].id +1
          // this.one_litigation.new_progress.name = this.one_litigation.new_progress.p_obj.text
          let {name} =  {} 
          let nprg = {
            id: this.one_litigation.progresses_attributes.data[this.one_litigation.progresses_attributes.data.length-1].id +1,
            name: this.one_litigation.new_progress.p_obj.value,
            processed_at: this.one_litigation.new_progress.processed_at,
            description: this.one_litigation.new_progress.description,
            internal_comment: this.one_litigation.new_progress.internal_comment,
          }
          console.log(this.one_litigation.new_progress);
          
          this.one_litigation.progresses_attributes.data.push({attributes: nprg})
          
          this.one_litigation.new_progress.name = this.one_litigation.new_progress.p_obj.value
          console.log(this.one_litigation.new_progress);
          
          let obj = {
            id: this.one_litigation.id,
            progresses_attributes: [this.one_litigation.new_progress],
          }
          Api.Litigation.update(obj)
            .then(r=>r.data)
            .then(liti=>{
              this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                title: `Processo movimentado com sucesso`,
                type: "success",
                showConfirmButton: false,
              })
              this.one_litigation.new_progress = {}

            })
            
        }, 500);
      }, 2000);
    },
    setupProfile() {
      // check for new or show
      if (this.is_new){
        // set the object to correct properties
        this.oneClient= {
          address:{},
          contracts: {
            data: [
              {
                litigations:[{
                  progresses_attributes:{}
                }]
              }
            ]
          },
          litigations:{
            data:[{
              progresses_attributes:{}
            }]
          },
        }
      } else {
        // console.log(this.$route.params.id);
        this.loading = true
        this.loadingText = 'Carregando'
        this.showClient(this.$route.params.id)
      }
    },
    remove_contract(i){
      //contracts
      (async () => {
				const { value: confirmation } = await this.$swal({
					title: "Excluir item?",
          type: "question",
          text: 'Essa ação é irreversível',
					showCancelButton: true,
					confirmButtonText: 'Sim',
					confirmButtonColor: '#ff9800',
					cancelButtonText: 'Não',
				})

				if (confirmation) {
          if (this.oneClient.contracts.data.length > 0){
            if (this.oneClient.contracts.data[i]){
              let item_to_delete = this.oneClient.contracts.data.splice(i,1)
              item_to_delete = item_to_delete[0]
              if (item_to_delete.id){
                Api.Item.delete(item_to_delete.id)
                  .then(response=>{
                    this.showProposal(this.$router.currentRoute.params.id)
                  })
              }
            }
          }
          this.contracts -= 1
				}
				}
			)()
    },
    ...mapActions({
      createClient: 'Client/create',
      updateClient: 'Client/update',
      showClient: 'Client/show',

      // function: 'Module/action'
    })
  },
  created () {
    // console.log(this.is_new)
    this.setupProfile()
    
  },
  watch: {
    dialog_litigation(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.oneClient = null
        this.loading = true
        this.loadingText = 'Atualizando'
        this.showClient(this.$route.params.id)
      }
    },
    contracts(nv,ov) {
      if (nv > ov){
        this.oneClient.contracts.data.push({litigations:[{progresses_attributes:[{}]}]})
      } else if (nv == false){
      }
    },
    createClientWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {          
          this.loading = false
          this.loadingText = null
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Cliente ${this.oneClient.name} criado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.$router.push('/clients')
        }, 1200);
    
      } else if (nv == false){
      }
    },
    updateClientWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {          
          this.loading = false
          this.loadingText = null
          this.showClient(this.$route.params.id)
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Cliente ${this.oneClient.name} editado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.$router.push('/clients')
        }, 1200);
    
      } else if (nv == false){
      }
    },
    oneClientVuex(nv,ov) {
      //setup parsing oneUser from vuex to local oneUser 
      if (nv){
        let {addresses, client_is, comment, contracts, corporate_info, document_number, email, id, litigations, name, phones} = nv

        // contracts.data[].attributes.litigations.data[].attributes
        let contracts_attr = contracts.data.map(obj=>obj.attributes)
        let contracts_lit_attr = []
        if (contracts_attr.length>0){
          contracts_attr.forEach(contract => {
            contracts_lit_attr = [...contracts_lit_attr, ...contract.litigations.data.map(obj=>obj.attributes)]
            contract.litigations= contracts_lit_attr.length>0? contracts_lit_attr : [{}]
            contracts_lit_attr = []
          });
        } else {
          contracts_attr = [{
            litigations:[{}]
          }]
        }
        // console.log({contracts_attr});
        
        let litigations_attr = litigations.data? litigations.data.map(obj=>obj.attributes) : litigations
        
        let all_litigations = [...litigations_attr, ...contracts_lit_attr]

        this.oneClient= {
          id,
          client_is,
          name,
          corporate_info,
          document_number,
          email,
          addresses,
          address:{
            ...addresses
          },
          phones,
          comment,
          
          // contracts,
          contracts: {
            data: contracts_attr
          },

          // litigations,
          litigations:{
            data: litigations_attr.length>0? litigations_attr : [{}]
          },

          all_litigations,
        }
        this.contracts = this.oneClient.contracts.data.length
        setTimeout(() => {
          this.loading= false
          this.loadingText = null
        }, 1200);
      } else if (nv == false){
    
      }
    }
  },
}
</script>

<style scoped>

</style>